// extracted by mini-css-extract-plugin
module.exports = {"onHoverFontWeight":"styles_onHoverFontWeight__kr8Lb","durationStopsHover":"styles_durationStopsHover__0V_Zo","durationStopsHoverText":"styles_durationStopsHoverText__ZzsSr"};